import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-locate-us-mobile",
  templateUrl: "./locate-us-mobile.component.html",
  styleUrls: ["./locate-us-mobile.component.scss"],
})
export class LocateUsMobileComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
